export default {
    getObject(key) {
        return sessionStorage.getItem(key)
    },

    setObject(key, value) {
        sessionStorage.setItem(key, JSON.stringify(value))
    },

    destroyObject(key) {
        sessionStorage.removeItem(key)
    },

    updateItem(key, property, value) {
        var obj = this.getObject(key);
        obj = JSON.parse(obj)
        obj[property] = value;
        this.setObject(key, obj);
        return obj;
    }
}